import { Button, ButtonProps } from '@wegroup/design-system';
import React from 'react';

interface Props {
  dataTestId?: string;
  hasError?: boolean;
  onClick: () => void;
}

const SingleOfferMainButton: React.FC<
  React.PropsWithChildren<Props & ButtonProps>
> = ({
  dataTestId = 'ADVISORY-CONVO_OFFERS_SINGLE-OFFER_MAIN-BUTTON',
  hasError,
  onClick,
  children,
  ...otherProps
}) => {
  return (
    <Button
      onClick={onClick}
      colorScheme="gray"
      borderRadius="0"
      borderBottomRightRadius="sm"
      p="7"
      zIndex="0"
      variant={hasError ? 'dangerPrimary' : 'primary'}
      data-test-id={dataTestId}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default SingleOfferMainButton;
